import React, { useState, ReactElement, memo } from 'react'
import { useTranslation } from 'react-i18next'
import Scrollbars from 'react-custom-scrollbars'
import { Switch, Route } from 'react-router';

import { languages } from '../../../i18n'
import { languageUrlPart } from '../../../routes/routes';
import { ToursPageMenuContent } from '../../../screens/tours/components';
import { TourPageMenuContent } from '../../../screens/tours-inner/components';
import { withAppStoreValue, ITour } from '../../../store';
import { INearByTour } from '../../../screens/tours/common';

interface IPageMenuAppStoreProps {
    tour: ITour
}

const PageMenuCore = memo(({ tour }: IPageMenuAppStoreProps) => {
    const { t, i18n: { languages: [language] } } = useTranslation();
    const [showMenu, setShowMenu] = useState(false)

    return (
        <div className="header-left-sm">
            <button onClick={() => setShowMenu(true)}>
                <img src="/images/icons/hamburger.png" alt="PM" />
            </button>

            {showMenu ?
                <div className="menu-body">
                    <div className="menu-header clearfix">
                        <a className="logo" href="/">
                            <img src="/images/logo/logo.jpg" alt="360 Tourist" />
                        </a>
                        <div className="close_icon">
                            <button onClick={() => setShowMenu(false)}>
                                {t('CLOSE')}
                                <img src="/images/icons/close-icon.png" alt="close" />
                            </button>
                        </div>
                        {/* <button onClick={handleCloseMenu} className="fr p-r15">
                    <img src="/images/icons/close-icon.png" alt="close" />
                </button> */}
                    </div>
                    <Scrollbars className="scroll-wrapper" >
                        <div className="clearfix">
                            <div style={{ textAlign: 'center' }}>
                                <ul style={{ padding: 0 }}>
                                    {languages.map(({ name, iconPath, code }) => (
                                        <li style={{ display: 'inline', padding: '0 8px' }} key={code}>
                                            {code === language ? <img style={{ width: '30px', height: 'auto', filter: 'grayscale(100%)', opacity: 0.6 }} src={iconPath} alt={name} /> : <a href={`/${code}`}><img style={{ width: '30px', height: 'auto' }} src={iconPath} alt={name} /></a>}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <Switch>
                                <Route exact path={`${languageUrlPart}/:countrySlug/:regionSlug/:citySlug/:tourSlug`} render={() => {
                                    return <TourPageMenuContent tour={tour} />
                                }} />
                                <Route path={[
                                    `${languageUrlPart}/around-me`,
                                    `${languageUrlPart}/:countrySlug`,
                                    `${languageUrlPart}/:countrySlug/find`,
                                    `${languageUrlPart}/:countrySlug/:regionSlug`,
                                    `${languageUrlPart}/:countrySlug/:regionSlug/:citySlug`,
                                    `${languageUrlPart}/:countrySlug/:regionSlug/:citySlug/:tourSlug/nearby`,
                                ]} render={({ location: { state: { nearByTour = undefined } } }) => {
                                    const actualNearByTour = nearByTour as INearByTour
                                    return <ToursPageMenuContent actualNearByTour={actualNearByTour}/>
                                }}/>
                            </Switch>
                        </div>
                    </Scrollbars>
                </div> : null
            }
        </div>
    )
})

export default withAppStoreValue<IPageMenuAppStoreProps>(PageMenuCore, ['tour']) 